export const YRS_OF_EXPERIENCE_DATA = [...Array.from(Array(20).keys())].map((item) => ({
   label: `${item + 1}`,
   value: item + 1,
}));
